import type { ReactNode } from "react";
import { ToastBar, Toaster } from "react-hot-toast";
import "./style.css";

export const ToastProvider = ({ children }: { children: ReactNode }) => {
  return (
    <>
      {children}
      <Toaster
        containerStyle={{
          zIndex: 2147483647,
          inset: 0,
        }}
        toastOptions={{
          icon: <></>,
          duration: 1500,
          success: {
            style: {
              fontSize: "14px",
              fontWeight: 700,
              backgroundColor: "#51AD93",
              color: "white",
              borderRadius: 0,
              width: "100%",
              maxWidth: "100vw",
            },
          },
          error: {
            style: {
              fontSize: "14px",
              fontWeight: 700,
              backgroundColor: "#F04A40",
              color: "white",
              borderRadius: 0,
              width: "100%",
              maxWidth: "100vw",
            },
          },
        }}
      >
        {(t) => (
          <ToastBar
            toast={t}
            style={{
              ...t.style,
              animation: t.visible
                ? `toast-enter 0.35s cubic-bezier(.21,1.02,.73,1) forwards`
                : `toast-exit 0.4s forwards cubic-bezier(.06,.71,.55,1)`,
            }}
          />
        )}
      </Toaster>
    </>
  );
};
